module.exports = __webpack_public_path__ + "img/ttshop_all1.2adee6da.svg";